import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyFieldFiller'
})
export class EmptyFieldFillerPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value === '' || value == undefined) {
      return '-';
    } else {
      return value;
    }
  }

}
